<template>
  <div class="col-12 p-0">
    <fullscreen ref="fullscreen" :fullscreen.sync="isFullScreen">
      <b-modal
        v-if="modalShowHideToggle"
        id="new-design"
        class="p-0"
        size="lg"
        hide-header
        hide-footer
      >
        <div class="column-modal-container">
          <div class="k-column-list-wrapper">
            <!-- <div class="row chartModalHeader">
            <div class="col-md-8 pl-0">
              <modalEVSLogo />
            </div>
          </div> -->
            <div class="col-12 px-4 modal-header-blue-bg">
              <div class="row">
                <h5 class="col-8 m-0 p-0">Column Settings</h5>
                <div class="col-md-4">
                  <div class="row">
                    <div
                      title="Close"
                      class="col-12 p-0 d-flex justify-content-end modal-close-button"
                    >
                      <img
                        id="projectInfoNavTimesButton"
                        type="button"
                        @click="closeModal()"
                        :src="cancelIcon"
                        style="width:60%"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 p-0 column-body">
              <div style="" class="pt-3 border-bottom column_main_wrapper">
                <div class="center-line"></div>
                <div class="col-12 col-md-6 p-0 column_child">
                  <div class="col-12">
                    <div class="row">
                      <div class="search-wrapper w-100">
                        <div class="col-12 p-0">
                          <label class="heading-label"
                            >Add/Remove Columns</label
                          >
                          <form>
                            <div class="input-group">
                              <span class="input-group-addon">
                                <img
                                  id="projectInfoNavTimesButton"
                                  type="button"
                                  :src="searchInterfaceSymbol"
                                  style="width:100%"
                                />
                              </span>
                              <input
                                type="text"
                                maxlength="32"
                                class="form-control"
                                placeholder="Search column by name"
                                name="searchColumnName"
                                id="searchColumnName"
                                @input="columnNameSearch"
                              />
                            </div>
                          </form>
                        </div>
                      </div>
                      <div class="w-100 h-100">
                        <div class="col-12 h-100">
                          <div class="row">
                            <div class="col-12 p-0 columns-list-container-left">
                              <div
                                :key="idx"
                                class="k-column-list-item col-sm-12 col-md-12 p-0"
                                v-for="(column, idx) in columns"
                              >
                                <label
                                  v-if="column.field !== 'CorpId'"
                                  :class="{
                                    checkDisabled: column.isDisabled,
                                  }"
                                  class="pt-2 pb-2"
                                  :for="'column-visiblity-show-' + idx"
                                >
                                  <input
                                    variant="primary"
                                    maxlength="32"
                                    :id="'column-visiblity-show-' + idx"
                                    :class="'k-checkbox'"
                                    :type="'checkbox'"
                                    :readOnly="true"
                                    :disabled="column.isDisabled"
                                    :checked="!column.hidden"
                                    @click="onToggleColumn(column)"
                                  />
                                  <span
                                    :for="'column-visiblity-show-' + idx"
                                    :class="'k-checkbox-label'"
                                    :style="{ userSelect: 'none' }"
                                    variant="light"
                                    >{{ column.title }}
                                  </span>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6 right-side-area column_child">
                  <div class="col-12 pr-0">
                    <div class="row">
                      <label class="heading-label pl-2">
                        Selected Columns
                        <span class="drag-title">(Drag to reorder)</span>
                      </label>
                      <div
                        class="col-12 p-0 pl-2 pr-2 columns-list-container-right"
                      >
                        <div
                          class="default-column-wrapper"
                          v-if="defaultColumns && defaultColumns.length"
                        >
                          <kendo-listbox
                            ref="listBox"
                            id="defaultKendoListBox"
                            :draggable="false"
                            :data-text-field="'title'"
                            :data-value-field="'field'"
                            :template="defaultColumnTmplate"
                            :data-source="defaultColumns"
                          >
                          </kendo-listbox>
                        </div>
                        <div class="moveable-column-wrapper">
                          <!-- <p>{{ selectedColumns }}</p> -->
                          <kendo-listbox
                            ref="listBox"
                            id="kendoListBox"
                            :draggable="true"
                            :connect-with="'selected'"
                            :drop-sources="['selected']"
                            :data-text-field="'title'"
                            :data-value-field="'field'"
                            :template="template"
                            :data-source="selectedColumns"
                          >
                          </kendo-listbox>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- button -->
              <div class="row pb-0 pr-3 pl-3 pt-3 modal_footer_set">
                <div class="col-12">
                  <div class="row">
                    <div
                      class="column-filter-button-wrapper w-100 d-flex save_selected"
                    >
                      <div class="col-12">
                        <div class="row">
                          <!-- <div class="col-md-12 col-lg-6 text-left p-0">
                          <div
                            class="k-column-list-item col-sm-12 col-md-12 p-0"
                          >
                            <label class="pt-2 pb-2">
                              <input
                                variant="primary"
                                maxlength="32"
                                :class="'k-checkbox'"
                                :type="'checkbox'"
                                v-model="save_selected"
                              />
                              <span :class="'k-checkbox-label'" variant="light"
                                >Keep the selected columns as my prefernce
                              </span>
                            </label>
                          </div>
                        </div> -->
                          <div class="col-md-12 col-lg-12 text-right p-0">
                            <button
                              type="button"
                              @click="handelApplyColumn"
                              class="btn applyButton"
                            >
                              Apply Columns
                            </button>
                            <button
                              type="button"
                              @click="handelResetColumn"
                              class="btn resetButton"
                            >
                              Reset
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
      <b-col lg="12" class="mb-2">
        <div class="w-100 vertical-align">
          <b-col class="col col-12 col-lg-12 p-0">
            <div class="row dropSearchAlign">
              <b-form-group label="Sector" class="col-6">
                <b-row class="">
                  <dropdownlist
                    :data-items="source"
                    :text-field="'SectorName'"
                    :data-item-key="'SectorID'"
                    :value="SelectedValue"
                    @change="onChange($event)"
                  >
                  </dropdownlist>
                  <b-button
                    class="btn filterBtn"
                    @click="getTableData"
                    :disabled="
                      this.pulseLoader.customeIndex.table ||
                        this.pulseLoader.customeIndex.chart ||
                        this.pulseLoader.pricePerformance.table ||
                        this.pulseLoader.RiskAdjusted.table
                    "
                  >
                    Search
                  </b-button>
                </b-row>
              </b-form-group>
              <b-form-group class="col-6 p-0" style="">
                <div class="col-12">
                  <b-row class="dropSearchAlign">
                    <b-input-group>
                      <b-button
                        v-b-modal.modal-sm.new-design
                        class="text-left btn-sm btn filterBtn btn-secondary column_filter"
                        variant="primary"
                        title="Manage column"
                        @click="openModalTrigger"
                        :disabled="columns && columns.length < 1"
                        >Manage column</b-button
                      >
                    </b-input-group>
                    <b-input-group>
                      <b-button
                        class="btn downloadBtn"
                        title="Export to Excel"
                        :theme-color="'primary'"
                        :disabled="result && result.data && !result.data.length"
                        @click="exportExcel(false)"
                      >
                        <img :src="DownloadIcon" alt="'DownloadIcon" />
                      </b-button>
                    </b-input-group>
                    <b-input-group>
                      <b-button
                        class="btn downloadBtn AllExport"
                        title="Export to Excel"
                        :theme-color="'primary'"
                        :disabled="
                          allExportButtonToggel.customeIndex.table ||
                            !allExportButtonToggel.customeIndex.data ||
                            allExportButtonToggel.pricePerformance.table ||
                            !allExportButtonToggel.pricePerformance.data ||
                            allExportButtonToggel.RiskAdjusted.table ||
                            !allExportButtonToggel.RiskAdjusted.data
                        "
                        @click="allCustomSaveExcel()"
                      >
                        All
                      </b-button>
                    </b-input-group>
                    <b-input-group class="d-none">
                      <button
                        type="button"
                        title="Full Screen"
                        class="btn downloadBtn mr-0"
                        @click="toggle"
                      >
                        <img :src="FullScreen" alt="'FullScreen" />
                      </button>
                    </b-input-group>
                  </b-row>
                </div>
              </b-form-group>
            </div>
          </b-col>
        </div>
      </b-col>
      <div class="col-12 position-relative p-0">
        <div class="row">
          <PulseLoader
            v-if="PulseLoaderToggle"
            :style="{ maxHeight: '500px' }"
            :title="LoaderTitle"
          ></PulseLoader>
        </div>
        <Grid
          :style="{ maxHeight: '500px' }"
          :data-items="result"
          :class="{
            no_records: result && result.data && !result.data.length,
          }"
          :take="dataState.take"
          :skip="dataState.skip"
          :sort="dataState.sort"
          :filter="dataState.filter"
          @datastatechange="dataStateChange"
          :columns="finalSelectedColumns"
          :sortable="true"
          :autocomplete="true"
          :resizable="true"
          :pageable="pageable"
          :page-size="pageSizeValue"
        >
          <template v-slot:myTemplate="{ props }">
            <custom
              :column="props.column"
              :filterable="props.filterable"
              :filter="props.filter"
              :sortable="props.sortable"
              :sort="props.sort"
              :columns="finalSelectedColumns"
              :result="products"
              @sortchange="(e) => props.onSortchange(e)"
              @filterchange="(e) => props.onFilterchange(e)"
              @closemenu="(e) => props.onClosemenu(e)"
              @contentfocus="(e) => props.onContentfocus(e)"
              @columnssubmit="onColumnsSubmit"
              @minMaxFilterHandler="minMaxFilterHandler"
              @filterchangeCustomHandler="filterchangeCustomHandler"
            />
          </template>
          <template v-slot:mcapTemplate="{ props }">
            <td class="k-table-td">
              <span
                v-if="props.dataItem[props.field]"
                class="d-block text-right"
                >{{
                  Number(props.dataItem[props.field]).toLocaleString("en-US", {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                  })
                }}
              </span>
            </td>
          </template>
          <template v-slot:recommendationTemplate="{ props }">
            <td class="k-table-td">
              <span
                v-if="props.dataItem[props.field]"
                class="status-style"
                :style="props.dataItem.color"
              >
                {{ props.dataItem[props.field] }}
              </span>
            </td>
          </template>
        </Grid>
        <p
          v-if="showMessageToggel"
          class="text-danger font_size_12 font-weight-bold"
        >
          Please click on apply to recalculate index as per revised filters
        </p>
      </div>
    </fullscreen>
  </div>
</template>
<script>
import "@progress/kendo-ui";
import {
  Grid,
  filterGroupByField,
  GridToolbar,
} from "@progress/kendo-vue-grid";
import { process } from "@progress/kendo-data-query";
import fullscreen from "vue-fullscreen";
import SectorKendoTable from "./SectorKendoTable.vue";
import Vue from "vue";
Vue.use(fullscreen);
// import Products from "./Peel_Hunt_Component/data.json";
import { provideLocalizationService } from "@progress/kendo-vue-intl";
import {
  saveExcel,
  workbookOptions,
  toDataURL,
} from "@progress/kendo-vue-excel-export";
import { saveAs } from "@progress/kendo-file-saver";

import { DropDownList } from "@progress/kendo-vue-dropdowns";
import { filterIcon } from "@progress/kendo-svg-icons";

import DownloadIcon from "../../../assets/img/icons/svg/download.svg";
import FullScreen from "../../../assets/img/icons/svg/full_screen.svg";
import cancelIcon from "../../../assets/img/icons/svg/cancelWhite.svg";
import CancelGray from "../../../assets/img/icons/svg/cancelGray.svg";
import SearchInterfaceSymbol from "../../../assets/img/icons/svg/search-interface-symbol.svg";
import kendo from "@progress/kendo-ui";
import { ListBox, ListBoxInstaller } from "@progress/kendo-listbox-vue-wrapper";
import PulseLoader from "./PulseLoader.vue";

export default {
  components: {
    Grid,
    custom: SectorKendoTable,
    // toolbar: GridToolbar,
    dropdownlist: DropDownList,
    "kendo-listbox": ListBox,
    PulseLoader,
  },
  props: {
    tableData: {
      default: [],
    },
    tableColumns: {
      default: [],
    },
    customIndexTableData: {
      default: [],
    },
    sectorDropDown: {
      default: [],
    },
    SelectedValueDropDown: {
      type: Object,
      default() {
        return {};
      },
    },
    pulseLoader: {
      default: {},
    },
    allExportButtonToggel: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  watch: {
    tableData: {
      deep: true,
      handler() {
        this.products = [];
        this.$nextTick(() => {
          if (this.tableData && this.tableData.length) {
            this.products = this.tableData;
            this.products.forEach((tableTd) => {
              tableTd.color = this.getColor(tableTd.Recommendation);
            });
          } else {
            this.products = [];
          }
          this.dataState.filter = {
            filters: [],
            logic: "and",
          };
          this.createDataState(this.products, this.dataState);
        });
      },
    },
    tableColumns: {
      deep: true,
      handler() {
        this.columns = [];
        this.finalSelectedColumns = [];
        this.$nextTick(() => {
          if (this.tableColumns && this.tableColumns.length) {
            let colClone = this.deepClone(this.tableColumns);
            this.finalSelectedColumns = this.cellRemove(colClone);
            this.columns = this.deepClone(this.finalSelectedColumns);
          } else {
            this.columns = [];
          }
        });
      },
    },
    sectorDropDown: {
      deep: true,
      handler() {
        // console.log("sectorDropDown", this.sectorDropDown);
        this.source =
          this.sectorDropDown && this.sectorDropDown.length
            ? this.sectorDropDown
            : [];
      },
    },
    SelectedValueDropDown: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.SelectedValue =
            this.SelectedValueDropDown.SectorName &&
            this.SelectedValueDropDown.SectorName.length > 0
              ? this.SelectedValueDropDown
              : {};
        });
      },
    },
  },
  data: function() {
    return {
      source: [],
      SelectedValue: {},
      DownloadIcon,
      FullScreen,
      cancelIcon: cancelIcon,
      cancelGray: CancelGray,
      searchInterfaceSymbol: SearchInterfaceSymbol,
      isFullScreen: false,
      modalShowHideToggle: false,
      result: [],
      selectedColumns: [],
      defaultColumns: [],
      finalSelectedColumns: [],
      save_selected: false,
      dataState: {
        take: 0,
        skip: 0,
        sort: [{ field: "Company", dir: "asc" }],
      },
      columns: [],
      products: [],
      checkboxFilterList: [],
      filterColumnList: [],
      currentFilterEvent: {},
      currentFilterFieldName: "",
      pagerType: "numeric",
      pagerButtons: 5,
      pagerInfo: true,
      pagerSizes: true,
      pagePrevNext: true,
      pageSizeValue: 10,
      LoaderTitle: "Please wait Loading...",
      PulseLoaderToggle: false,
      showMessageToggel: false,
    };
  },
  computed: {
    pageable() {
      return {
        refresh: true,
        buttonCount: this.pagerButtons,
        info: this.pagerInfo,
        type: this.pagerType,
        pageSizes: [10, 15, 20, 100],
        previousNext: this.pagePrevNext,
        pageSizeValue: this.pageSizeValue,
      };
    },
  },
  provide() {
    return {
      kendoIcons: {
        type: "svg",
        icons: {
          "more-vertical": filterIcon,
        },
      },
    };
  },
  created: function() {
    this.createDataState(this.products, {
      take: 10,
      skip: 0,
      sort: [{ field: "Company", dir: "asc" }],
    });
  },
  emits: ["peelHuntLoaderValue", "allTableDataExportEmit"],
  methods: {
    createDataState(data, dataState) {
      // this.PulseLoaderToggle = true;
      this.result = process(data.slice(0), dataState);
      let dataStateClone = JSON.parse(JSON.stringify(dataState));
      dataStateClone.take = data.length;
      let resultClone = process(data.slice(0), dataStateClone);
      this.$emit("sectorKendoTableData", resultClone);
      this.PulseLoaderToggle = false;
      // this.$emit("sectorKendoTableData", this.result);
      // console.log("sectorKendoTableData-->data", data);
      // console.log("sectorKendoTableData-->this.result.data", this.result.data);
      // console.log("sectorKendoTableData-->dataState", dataState);
      // console.log("sectorKendoTableData-->resultClone", resultClone);
      this.dataState = dataState;
      this.pageSizeValue = this.dataState.take;
    },
    dataStateChange(e) {
      // this.PulseLoaderToggle = true;
      this.$emit("peelHuntLoaderValue", true);
      setTimeout(() => {
        // console.log("dataStateChange(e)", e);
        let take =
          e.event && e.event.value ? e.event.value : this.dataState.take;
        this.pageSizeValue = take;
        e.data.take = take;
        this.dataState = e.data;
        let filterObjTemp = {
          column: {
            filter: "string",
          },
        };
        this.bothDataFilterHandler(filterObjTemp);
        this.$emit("peelHuntLoaderValue", false);
        this.PulseLoaderToggle = false;
      }, 10);
    },
    onColumnsSubmit(columnsState) {
      this.columns = columnsState;
    },
    // -------------->
    onChange(event) {
      this.$nextTick(() => {
        this.SelectedValue = event.target.value;
      });
    },
    getTableData() {
      // console.log("this.SelectedValue", this.SelectedValue);
      if (this.SelectedValue.SectorID) {
        this.$emit("selectedSectorValue", this.SelectedValue);
        this.$emit("getSectorTableData", this.SelectedValue);
      } else {
        alert("Please select valid sector");
      }
    },
    // export table data here in excel--------
    async exportExcel(value) {
      //   this.showToast("Preparing data for download.", "warning");
      // console.log("this.result", this.result);
      const columnsToExportCopy = [...this.finalSelectedColumns];
      // const columnsToExportCopy = value
      // ? [...this.columns]
      // : [...this.defaultColumns, ...this.selectedColumns];
      let columnDeepCopy = this.deepClone(columnsToExportCopy);
      // let columnsToExportList = await [...this.hiddenFalse(columnDeepCopy)];
      // let downloadData = value ? this.products : this.result.data;
      let downloadData =
        this.result && this.result.data ? this.result.data : this.products;
      // console.log("columnsToExportCopy", columnsToExportCopy);
      // console.log("downloadData", downloadData);
      saveExcel({
        data: downloadData,
        fileName: "Sector Report",
        columns: columnDeepCopy,
      });
      //   this.showToast("File downloaded successfully.", "success");
    },
    allCustomSaveExcel() {
      // let downloadData = this.products;
      const columnsToExportCopy = [...this.finalSelectedColumns];
      let columnDeepCopy = this.deepClone(columnsToExportCopy);
      this.$emit("allTableDataExportEmit", {
        data: this.products,
        columns: columnDeepCopy,
      });
    },
    hiddenFalse(columns) {
      let Column = columns;
      Column.forEach((col) => {
        col.hidden = false;
      });
      return Column;
    },
    // full screen table
    toggle() {
      this.isFullScreen = !this.isFullScreen;
      // // console.log("ppppp", window.parent);
      // // console.log(
      // //   "window.frameElement.parentElement",
      // //   window.frameElement.parentElement
      // // );
      // const iframeParent = window.frameElement.parentElement;
      // if (iframeParent) {
      //   iframeParent.classList.add("fullScreenIframe");
      // }
      // // let iframe = document.querySelector(".d_flex.just_content_space iframe");
      // // if (iframe) {
      // //   iframe.classList.toggle("fullScreenIframe");
      // // }
    },
    // modal button ---------
    // when column setting modal open
    openModalTrigger() {
      // show modal
      this.modalShowHideToggle = true;
      // default column/sticky column
      let defaultCols = ["company", "rating", "mcap"];
      // empty both
      this.defaultColumns = [];
      this.selectedColumns = [];
      // because after apply finalSelectedColumns change, before that columns data change
      this.columns = this.deepClone(this.finalSelectedColumns);
      this.columns.forEach((col) => {
        // not show corpId on UI
        if (col.field !== "CorpId") {
          // set only default/stick column name
          if (defaultCols.indexOf(col.field.toLowerCase()) > -1) {
            if (col.isDisabled) {
              if (!col.hidden) {
                this.defaultColumns.push(col);
              }
            }
          } else {
            if (!col.hidden) {
              // rest of the default/sticky column
              this.selectedColumns.push(col);
            }
          }
        }
      });
      // add clear event in every time when we udpate selectedColumns
      this.addCustomeClearMethod();
    },
    // set event after selectedColumns list update
    addCustomeClearMethod() {
      let that = this;
      // console.log("this-------", this.selectedColumns);
      if (this.selectedColumns.length) {
        setTimeout(() => {
          let removeItemformList = document.querySelectorAll(
            ".columnListCancel"
          );
          if (removeItemformList.length) {
            for (var i = 0; i < removeItemformList.length; i++) {
              removeItemformList[i].addEventListener("click", function(event) {
                event.preventDefault();
                that.removeSelectedColumnsList(
                  this.getAttribute("data-column-field")
                );
              });
            }
          }
        }, 10);
      }
    },
    // remove that column form list after click on clear/X button
    removeSelectedColumnsList(val) {
      // selected column update
      this.selectedColumns = this.selectedColumns.filter((selectedCol) => {
        return selectedCol.field !== val;
      });
      // uncheck form UI
      this.columns = this.columns.map((column, idx) => {
        return column.field === val && !column.isDisabled
          ? { ...column, hidden: true }
          : column;
      });
      // add clear/X event
      this.addCustomeClearMethod();
    },
    // after apply button click save change and update column in table
    async handelApplyColumn() {
      // console.log("handelApplyColumn");
      // here columns devide in three parts
      // 1. Stick/default columns - this.defaultColumns
      // 2. those are show on table - firstVisibleCol
      // 3. uncheck/hidden column list that append in last of the column list - restHiddenCol
      let firstVisibleCol = [];
      let restHiddenCol = [];
      this.columns.forEach((cols) => {
        let remainData = this.selectedColumns.find((sCol) => {
          return cols.field === sCol.field;
        });
        if (remainData) {
          firstVisibleCol.push(cols);
        } else {
          if (!cols.isDisabled) {
            let defaultCols = ["company", "rating", "mcap"];
            if (defaultCols.indexOf(cols.field.toLowerCase()) < 0) {
              restHiddenCol.push(cols);
            }
          }
        }
      });
      // combine array and deep copy
      let fullCol = [
        ...this.defaultColumns,
        ...firstVisibleCol,
        ...restHiddenCol,
      ];
      fullCol = this.deepClone(fullCol);
      // collect all selected filed name list
      let AllSelectedColumnList = document.querySelectorAll(
        ".col-12.p-0.mb-1.column-list-label span.columnListCancel"
      );
      let selectedColumnNameList = [];
      for (let i = 0; i < AllSelectedColumnList.length; i++) {
        let fieldName = AllSelectedColumnList[i].getAttribute(
          "data-column-field"
        );
        selectedColumnNameList.push(fieldName);
      }
      // sequence array generate here
      let sequenceColumn = [];
      selectedColumnNameList.forEach((sColName) => {
        let col = fullCol.find((fCol) => {
          return fCol.field === sColName;
        });
        if (col) {
          sequenceColumn.push(col);
        }
      });
      // combile defautl and sequence and hidden columns
      sequenceColumn = [
        ...this.defaultColumns,
        ...sequenceColumn,
        ...restHiddenCol,
      ];
      this.finalSelectedColumns = this.deepClone(sequenceColumn);
      this.closeModal();
    },
    // when user click on reset button then set the default column selected rest unchecked
    handelResetColumn() {
      // this.resetColumnsSet();
      // console.log("handelResetColumn");
      let defaultCols = ["company", "rating", "mcap"];
      // take initial data that come from API
      this.columns = this.deepClone(this.tableColumns);
      // empty data
      this.defaultColumns = [];
      this.selectedColumns = [];
      this.columns.forEach((col) => {
        if (col.field !== "CorpId") {
          // if column name find
          if (defaultCols.indexOf(col.field.toLowerCase()) > -1) {
            // must be disabled
            if (col.isDisabled) {
              // must hidden false
              if (!col.hidden) {
                this.defaultColumns.push(col);
              }
            }
          } else {
            // if disabled true
            if (col.isDisabled) {
              // hidden false
              if (!col.hidden) {
                // column name not stick/default
                if (defaultCols.indexOf(col.field.toLowerCase()) < 0) {
                  this.selectedColumns.push(col);
                }
              }
            } else {
              // uncheck rest of the columns
              col.hidden = true;
            }
          }
        }
      });
      this.columns = this.cellRemove(this.columns);
      this.addCustomeClearMethod();
    },
    // when user click on check/unchek then update columns and selectedColumns
    onToggleColumn(column) {
      this.columns.forEach((col) => {
        if (col.field === column.field) {
          // console.log("-------", column);
          col.hidden = !column.hidden;
          return;
        }
      });
      if (column.hidden) {
        this.selectedColumns = this.selectedColumns.filter((item) => {
          return item.field !== column.field;
        });
      } else {
        this.selectedColumns.push(column);
      }
      this.addCustomeClearMethod();
    },
    // column filter search event
    columnNameSearch(event) {
      event.preventDefault();
      let inputValue = event.target.value.toLowerCase();
      let columnListParent = document.querySelectorAll(
        ".columns-list-container-left .k-column-list-item"
      );
      let columnListParentSpan = document.querySelectorAll(
        ".columns-list-container-left .k-column-list-item label span"
      );
      for (let i = 0; i < columnListParent.length; i++) {
        let title = columnListParentSpan[i].textContent;
        if (title.toLowerCase().includes(inputValue)) {
          columnListParent[i].style.display = "block";
        } else {
          columnListParent[i].style.display = "none";
        }
      }
    },
    // reordable list template
    template: function(e) {
      var template = kendo.template(`
      <div
        class="k-column-list-item col-sm-12 col-md-12 p-0"
      >
        <label class="col-12 p-0 mb-1 column-list-label">
          <span
            data-column-field="#=field#"
            data-column-id="#=id#"
            :class="'k-checkbox-label'"
            variant="light"
            >
            #=title#
          </span>
          <span
            data-column-user-role="#=isDisabled#"
            data-column-field="#=field#"
            data-column-id="#=id#"
            id="clear-item-#=field#"
            style="display: inline-block"
            class="columnListCancel"
            type="button"
          ><span>
        </label>
      </div>
      `);
      return template(e);
    },
    // selected column list with close button
    defaultColumnTmplate: function(e) {
      var template = kendo.template(`
      <div
        class="k-column-list-item col-sm-12 col-md-12 p-0"
      >
        <label class="col-12 p-0 mb-1 column-list-label">
          <span
            data-column-field="#=field#"
            data-column-id="#=id#"
            :class="'k-checkbox-label'"
            variant="light"
            >
            #=title#
          </span>
        </label>
      </div>
      `);
      return template(e);
    },
    deepClone(data) {
      return JSON.parse(JSON.stringify(data));
    },

    // column reordable
    columnReorder: function(options) {
      // this.finalSelectedColumns = options.target._columns;
      let _columns = options.target._columns;
      let _selectedColumns = [];
      for (let col of _columns) {
        let columnObj = this.columns.find((column) => {
          // console.log("indexxxxxxxxxx-22", column.field);
          return column.field === col.field;
        });
        // if (
        //   col.field !== "CorpId" &&
        //   col.field !== "Company" &&
        //   col.field !== "Rating"
        // ) {
        // console.log("finalSelectedColumns", col.hidden);
        _selectedColumns.push(columnObj);
        // }
        // console.log("indexxxxxxxxxx", col);
      }
      this.selectedColumns = [];
      this.selectedColumns = _selectedColumns;
      // console.log("this.selectedColumns555", this.selectedColumns);
      this.handelApplyColumnCheck = true;
      // console.log("_selectedColumns", _selectedColumns);
      this.getData();
      this.addCustomeClearMethod();
    },
    cellRemove: (arr) => {
      let data = [];
      arr.forEach((element) => {
        let obj = element;
        // console.log("element", element);
        obj.className = obj.field !== "Company" ? "text-right" : "";
        if (obj.field === "Recommendation") {
          obj.cell = "recommendationTemplate";
        }
        let width = 0;
        if (obj.title.toLowerCase() === "company") {
          width = 200;
        } else if (obj.title.toLowerCase() === "market cap(m)") {
          obj.cell = "mcapTemplate";
          width = obj.title.length * 8 + 6 + 16 + 30;
        } else if (obj.title.length) {
          width = obj.title.length * 8 + 6 + 16 + 30;
        }
        // else if (obj.title.length <= 5) {
        //   width = obj.title.length * 10 + 50;
        // } else if (obj.title.length <= 10) {
        //   width = obj.title.length * 8 + 70;
        // } else if (obj.title.length <= 15) {
        //   width = obj.title.length * 6 + 80;
        // } else if (obj.title.length > 15) {
        //   width = obj.title.length * 10 + 30;
        // }
        obj.width = width + "px";
        if (obj.field !== "CorpId") {
          data.push(obj);
        }
      });
      return data;
    },
    getColor(value) {
      let obj = { background: "#FFF" };
      switch (value.toLowerCase()) {
        case "buy":
          obj.background = "#61bb95";
          break;
        case "hold":
          obj.background = "#ffbf00";
          break;
        case "sell":
          obj.background = "#f6353e";
          break;
        case "under review":
          obj.background = "#b5b5b5";
          break;
        case "add":
          obj.background = "#9cc094";
          break;
        case "reduce":
          obj.background = "#f85b62";
          break;
        case "outperform":
          obj.background = "#61bb95";
          break;
        case "neutral":
          obj.background = "#ffbf00";
          break;
        case "underperform":
          obj.background = "#f6353e";
          break;
        default:
          obj.background = "#ffffff";
      }
      return obj;
    },
    closeModal() {
      this.save_selected = false;
      this.modalShowHideToggle = false;
    },
    // modal code end here ------
    minMaxFilterHandler(filterObject) {
      this.showMessageToggel =
        this.customIndexTableData &&
        this.customIndexTableData.table_column &&
        this.customIndexTableData.table_column.length &&
        this.customIndexTableData.table_data &&
        this.customIndexTableData.table_data.length
          ? true
          : false;
      // console.log("filterObject>>>>>>>>>>", filterObject);
      this.currentFilterFieldName = filterObject.column.field;
      if (filterObject.minValue && filterObject.maxValue) {
        this.filterColumnList = this.columnFilterValueMinMaxHandler(
          filterObject
        );
        this.bothDataFilterHandler(filterObject);
      } else {
        this.finalSelectedColumns.filter((col) => {
          if (col.field == filterObject.column.field) {
            col.minValue = filterObject.minValue;
            col.maxValue = filterObject.maxValue;
            if (col.minValue.length || col.maxValue.length) {
              col.headerClassName = "customMenu active";
            } else {
              col.headerClassName = "";
            }
          }
        });
        let filterColumnListArr = this.filterColumnList.filter((col) => {
          let key = Object.keys(col)[0];
          return col[key].field !== filterObject.column.field;
        });
        this.filterColumnList = [];
        this.filterColumnList = filterColumnListArr;
        this.bothDataFilterHandler(filterObject);
      }
      let applySectorFilter = [];
      this.filterColumnList.forEach((fCol) => {
        this.columns.find((col) => {
          if (col.field === Object.keys(fCol)[0]) {
            let obj = {
              FieldName: col.field,
              finYear: col.finYear,
              minValue: fCol[col.field].minValue,
              maxValue: fCol[col.field].maxValue,
            };
            applySectorFilter.push(obj);
            return true;
          }
        });
      });
      this.$emit("applySectorFilter", applySectorFilter);
    },
    columnFilterValueMinMaxHandler(filterObject) {
      let filterColumnList = [];
      if (
        filterObject &&
        filterObject.column &&
        filterObject.column.field &&
        filterObject.minValue &&
        filterObject.minValue
      ) {
        this.finalSelectedColumns.forEach((col) => {
          if (col && col.filter && col.filter === "numeric") {
            if (col.field === filterObject.column.field) {
              col.minValue = filterObject.minValue;
              col.maxValue = filterObject.maxValue;
              let obj = {
                [col.field]: {
                  field: filterObject.column.field,
                  minValue: filterObject.minValue,
                  maxValue: filterObject.maxValue,
                },
              };
              if (
                filterObject &&
                filterObject.column &&
                filterObject.column.filter &&
                filterObject.column.filter === "numeric"
              ) {
                if (
                  filterObject.minValue.length > 0 ||
                  filterObject.maxValue.length > 0
                ) {
                  col.headerClassName = "customMenu active";
                } else {
                  col.headerClassName = "";
                }
              }
              filterColumnList.push(obj);
            } else {
              if (!col.minValue.length && !col.maxValue.length) {
                col.minValue = "";
                col.maxValue = "";
                col.headerClassName = "";
              } else {
                if (col.minValue.length || col.maxValue.length) {
                  let obj = {
                    [col.field]: {
                      field: col.field,
                      minValue: col.minValue,
                      maxValue: col.maxValue,
                    },
                  };
                  filterColumnList.push(obj);
                  col.headerClassName = "customMenu active";
                }
              }
            }
          }
        });
        // console.log("filterColumnList===>>", filterColumnList);
        // console.log("finalSelectedColumns", this.finalSelectedColumns);
        return filterColumnList;
      } else {
        return this.finalSelectedColumns;
      }
    },
    bothDataFilterHandler(filterObject) {
      let fullDefaultData = this.deepClone(this.products);
      let resultsData = this.minMaxDataFilter(fullDefaultData);
      this.createDataState(resultsData, this.dataState);
      // console.log("filterObject!!!!!!!!!!", resultsData);
      setTimeout(() => {
        this.filterGroupByFieldHandler(
          this.currentFilterFieldName,
          this.dataState,
          filterObject
        );
      }, 10);
    },
    minMaxDataFilter(fullDefaultData) {
      let resultsData = fullDefaultData;
      // console.log("filterColumnList", this.filterColumnList);
      // console.log("filterObject", filterObject);
      this.filterColumnList.forEach((fColList, index) => {
        if (index < 1) {
          resultsData = this.minMaxfullDataFilter(fullDefaultData, fColList);
        } else {
          resultsData = this.minMaxfullDataFilter(resultsData, fColList);
        }
      });
      return resultsData;
    },
    minMaxfullDataFilter(fullDefaultData, fColList) {
      let resultData = [];
      fullDefaultData.forEach((res) => {
        let key = Object.keys(fColList)[0];
        let fData;
        if (fColList[key].minValue.length && fColList[key].maxValue.length) {
          if (
            Number(res[key]) >= Number(fColList[key].minValue) &&
            Number(res[key]) <= Number(fColList[key].maxValue)
          ) {
            fData = res;
          }
        } else {
          if (fColList[key].minValue.length || fColList[key].maxValue.length) {
            if (fColList[key].minValue.length) {
              if (Number(res[key]) >= Number(fColList[key].minValue)) {
                fData = res;
              }
            } else if (fColList[key].maxValue.length) {
              if (Number(res[key]) <= Number(fColList[key].maxValue)) {
                fData = res;
              }
            }
          }
        }
        if (fData) {
          resultData.push(fData);
        }
      });
      // console.log("resultData", resultData);
      return resultData;
    },
    filterGroupByFieldHandler(fieldName, dataState, filterObject) {
      // console.log("------------> fieldName", fieldName);
      // console.log("------------> dataState", dataState);
      this.currentFilterFieldName = fieldName;
      this.currentFilterChangeCheck(fieldName, dataState, filterObject);
    },
    currentFilterChangeCheck(fieldName, dataState, filterObject) {
      let filterArr =
        dataState && dataState.filter && dataState.filter.filters
          ? dataState.filter.filters
          : [];
      if (
        filterObject &&
        filterObject.column &&
        filterObject.column.filter &&
        filterObject.column.filter === "string"
      ) {
        if (dataState && dataState.filter && filterArr && filterArr.length) {
          for (let i = 0; i < filterArr.length; i++) {
            let filFind = filterArr[i].filters.find((colFilter) => {
              return colFilter.field === fieldName;
            });
            if (filFind && filFind != undefined && filFind.field) {
              this.addRemoveActiveClass(filFind, filFind.field);
            } else {
              this.addRemoveActiveClass(filFind, fieldName);
            }
          }
        } else {
          let filFind = filterArr.find((colFilter) => {
            return colFilter.field === fieldName;
          });
          this.addRemoveActiveClass(filFind, fieldName);
        }
      }
    },
    addRemoveActiveClass(filFind, fieldName) {
      let changedColumn = this.finalSelectedColumns.find((column) => {
        if (column.field === fieldName) {
          if (filFind) {
            column.headerClassName = "customMenu active";
          } else {
            column.headerClassName = "";
          }
          return;
        }
      });
    },
    filterchangeCustomHandler(filter, column) {
      // console.log("filterchangeCustomHandler -> PARENT filter", filter);
      // console.log("filterchangeCustomHandler -> PARENT column", column);
      let filterObjTemp = {
        column,
      };
      this.currentFilterFieldName = column.field;
      setTimeout(() => {
        this.filterGroupByFieldHandler(
          this.currentFilterFieldName,
          this.dataState,
          filterObjTemp
        );
        let fullDefaultData = this.deepClone(this.products);
        let resultsData = this.minMaxDataFilter(fullDefaultData);
        this.createDataState(resultsData, this.dataState);
        this.bothDataFilterHandler(filterObjTemp);
      }, 100);
    },
  },
};
</script>
